import { FC } from 'react';
import { MulticolorBarProps } from './MulticolorBar.types';
import { MulticolorBarStyled, StyledRemainingText } from './MulticolorBar.styles';

export const MulticolorProgressBar: FC<MulticolorBarProps> = ({
  values,
  height,
  borderRadius,
  remainingText,
  isTv,
  disabled = false,
  showEndArrow = false,
  overflow = 'hidden',
  display,
  weightRemainingText = 600,
  remainingTextColor = 'neutral-80',
}) => {
  return (
    <MulticolorBarStyled
      disabled={disabled}
      showArrow={showEndArrow}
      arrowColor={`var(--allie-color-${values[values.length - 2]?.color})`}
      height={height}
      borderRadius={borderRadius}
      overflow={overflow}
      display={display}
    >
      {values.map(({ value, color, children }, index, arr) => {
        const dividerNeeded = color === arr[index + 1]?.color;

        const isLastChild = values.length - 1 === index;

        return (
          <div
            key={`${index}-${value}`}
            className="bar"
            style={{
              maxWidth: value < 1 ? 'auto' : '100%',
              width: `calc(${value}% - ${dividerNeeded ? '1px' : isLastChild ? '1px' : '0px'})`,
              backgroundColor: `var(--allie-color-${color})`,
              ...(dividerNeeded && {
                // eslint-disable-next-line max-len
                borderRight: `1px solid var(--allie-color-${color === 'neutral-40' ? 'light-30' : color})`,
              }),
            }}
          >
            {children}
          </div>
        );
      })}
      {remainingText && (
        <StyledRemainingText
          {...(isTv && { type: 'h5' })}
          color={remainingTextColor}
          weight={weightRemainingText}
        >
          {remainingText}
        </StyledRemainingText>
      )}
    </MulticolorBarStyled>
  );
};
